import { render, staticRenderFns } from "./Expertnav.vue?vue&type=template&id=338341d7&"
import script from "./Expertnav.vue?vue&type=script&lang=js&"
export * from "./Expertnav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports